import { useChannelStore } from "./channel-store";
import { useChannelRoomStore } from "./channelroom-store";
import { useChatStore } from "./chat-store";
import { useFriendStore } from "./friend-store";
import { useGlobalStore } from "./global-store";

export const clearStore = async (): Promise<void> => {
    await useFriendStore.getState().destroy();
    await useChannelRoomStore.getState().destroy();
    await useGlobalStore.getState().destroy();
    await useChatStore.getState().destroy();
    await useChannelStore.getState().destroy();
};
